import { Component, OnInit, Renderer2, AfterViewInit } from "@angular/core";
import { Router } from "@angular/router";
import { first } from "rxjs/operators";
import { DashboardQuantiteUtilisateur } from "src/app/new-dashboard/core/model/dashboard-quantite-utilisateur";
import { DashboardAdminService } from "src/app/new-dashboard/core/service/dashboard-admin.service";

@Component({
  selector: "app-audience",
  templateUrl: "./audience.component.html",
  styleUrls: ["./audience.component.scss"],
})
export class AudienceComponent implements OnInit, AfterViewInit {
  site_statistics: boolean = false;
  totalCounter: boolean = false;

  qteUtilisateur: number;
  qteAgence: number;
  qteVille: number;
  qteRegion: number;
  qteDirection: number;
  qteDepartement: number;
  qteEmployeur: number;

  dashboardQuantiteUtilisateur: DashboardQuantiteUtilisateur[];

  constructor(
    private _router: Router,
    private _dashboardAdminService: DashboardAdminService,
    private renderer: Renderer2
  ) {}

  renderExternalScript(src: string): HTMLScriptElement {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = src;
    script.async = true;
    script.defer = true;
    this.renderer.appendChild(document.body, script);
    return script;
  }

  ngOnInit() {
    this.getDashboardQuantiteUtilisateur();
    this.getDashboardQuantiteAgence();
    this.getDashboardQuantiteVille();
    this.getDashboardQuantiteRegion();
    this.getDashboardQuantiteDirection();
    this.getDashboardQuantiteDepartement();
    this.getDashboardQuantiteEmployeur();
  }

  ngAfterViewInit() {
    this.renderExternalScript("../../assets/js/google-analytic.js").onload =
      () => {
        console.log("google-analytic js Script loaded");
      };
  }

  getDashboardQuantiteUtilisateur() {
    this._dashboardAdminService
      .getDashboardQuantiteUtilisateur()
      .pipe(first())
      .subscribe(
        (data) => {
          this.qteUtilisateur = data.quantite;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  getDashboardQuantiteAgence() {
    this._dashboardAdminService
      .getDashboardQuantiteAgence()
      .pipe(first())
      .subscribe(
        (data) => {
          this.qteAgence = data.quantite;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  getDashboardQuantiteVille() {
    this._dashboardAdminService
      .getDashboardQuantiteVille()
      .pipe(first())
      .subscribe(
        (data) => {
          this.qteVille = data.quantite;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  getDashboardQuantiteRegion() {
    this._dashboardAdminService
      .getDashboardQuantiteRegion()
      .pipe(first())
      .subscribe(
        (data) => {
          this.qteRegion = data.quantite;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  getDashboardQuantiteDirection() {
    this._dashboardAdminService
      .getDashboardQuantiteDirection()
      .pipe(first())
      .subscribe(
        (data) => {
          this.qteDirection = data.quantite;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  getDashboardQuantiteDepartement() {
    this._dashboardAdminService
      .getDashboardQuantiteDepartement()
      .pipe(first())
      .subscribe(
        (data) => {
          this.qteDepartement = data.quantite;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  getDashboardQuantiteEmployeur() {
    this._dashboardAdminService
      .getDashboardQuantiteEmployeur()
      .pipe(first())
      .subscribe(
        (data) => {
          this.qteEmployeur = data.quantite;
        },
        (error) => {
          console.log(error);
        }
      );
  }
}
